import Schedule from "./schedule.service";

const scheduleModule = angular
  .module("app.services.schedule", [])
  .service("Schedule", Schedule);

export default scheduleModule;



// WEBPACK FOOTER //
// ./src/services/schedule/schedule.module.js